import {
  ControllerProps,
  FieldValues,
  Path,
  UseControllerReturn,
  UseControllerProps,
} from 'react-hook-form';

import { FileUploadInputProps, FileUploadInput } from '../FileUploadInput/FileUploadInput';

import { mapBooleanValueMessage } from './valueMessage';
import { makeControlledInput } from './makeControlledInput';

export const propsMapperFileUpload = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends Path<TFieldValues> = Path<TFieldValues>
>(
  controllerRenderProps: UseControllerReturn<TFieldValues, TName>,
  controllerProps?: Omit<ControllerProps<TFieldValues, TName>, 'render'>,
  defaultInputProps?: Partial<FileUploadInputProps>
): FileUploadInputProps => {
  const {
    field: { onChange, name, value },
    fieldState: { error },
  } = controllerRenderProps;
  const rules = controllerProps?.rules;
  const controllerRequired = rules?.required;
  return {
    ...defaultInputProps,
    onChange,
    onFinish: ({ publicUrl }): void => onChange(publicUrl),
    name,
    value,
    required: mapBooleanValueMessage(controllerRequired),
    error: Boolean(error),
  };
};

export const controlledFileUpload =
  <TFieldValues extends FieldValues = FieldValues>() =>
  <
    TDefaultControllerProps extends Partial<UseControllerProps<TFieldValues, TName>>,
    TName extends Path<TFieldValues>
  >(
    name: TName,
    defaultControllerProps?: TDefaultControllerProps
  ) =>
    makeControlledInput<TFieldValues>()({
      name,
      defaultControllerProps,
      Component: FileUploadInput,
      propsMapper: propsMapperFileUpload,
    });
